import { render, staticRenderFns } from "./ProductCardFeatures.vue?vue&type=template&id=6998bea6&"
import script from "./ProductCardFeatures.vue?vue&type=script&lang=js&"
export * from "./ProductCardFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports